export default __webpack_public_path__ + "static/media/image18.6cc21394.png";